import React, { useEffect, useState } from "react";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { slidersData } from '../data.js';

import '../../css/custom-slider.css'; // Importer vos styles personnalisés

const marks = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6'
};

const marksGradiant = {
    1: '0',
    2: '20',
    3: '40',
    4: '60',
    5: '80',
    6: '100'
}

const NeedSliderRange = ({title, range, setRange, handleNeedsChange, railColor}) => {
    const [message, setMessage] = useState("");
    const [showMessage, setShowMessage] = useState(false);
    const maxRangeLength = 3; // Longueur maximale entre les poignées
    const [gradiant, setGradiant] = useState(['0', '20', '60']);

    // Masquer le message après 5 secondes
    const displayMessage = (message) => {
        setShowMessage(true);
        setMessage(message);
    };

    const handleChangeRange = (newRange) => {
        const [min, max] = newRange;

        // Limiter l'écart entre les poignées
        if (max - min > maxRangeLength) {
            displayMessage(slidersData["MaxGap"][1]);
            return;
        }

        displayMessage(slidersData[title][newRange[0]]);
        handleNeedsChange(newRange);
        setRange(newRange);
    };

    // Recalcul des couleurs en fonction du range
    useEffect(() => {
        const [min, max] = range;
        setGradiant([marksGradiant[min], marksGradiant[max], marksGradiant[(min > 3 ? 3 : min) + maxRangeLength]]);
    }, [range]);


    return (
        <div className="mutelios-slider">
            <p className="mutelios-slider-title">{title}</p>
            <div className="mutelios-slider tw-px-3">
                <Slider
                range
                min={1}
                max={6}
                value={range}
                marks={marks}
                onChange={handleChangeRange}
                allowCross={true}
                pushable={true}
                styles={{
                    rail:{
                        backgroundColor: "transparent",
                        background: "linear-gradient(to right, #0075BF " + gradiant[0] + "%, transparent "
                            + gradiant[0] + "%, transparent "+ gradiant[1] +"%, rgb(236, 102, 8, 0.24) "+ gradiant[1] + "%, rgb(236, 102, 8, 0.24) " + gradiant[2] +"%, "+ railColor + " "+ gradiant[2] +"%)"},
                    track:{backgroundColor: "rgb(236, 102, 8)"},
                }}
            />
            </div>
            {showMessage && <p className="tw-text-body-small tw-py-2 tw-px-4">{message}</p>}
        </div>
    )
}

export default NeedSliderRange;